const en = {
    "home":"Home",
    "about":"About us",
    "projects":"Projects",
    "cooperate":"Partnership",
    "news":"News",
    "hr":"Human resource",
    "contacts":"Contacts",
    "strip":"Stripping and extraction of open pits",
    "miningSup":"Mining support",
    "rentalEq":"Equipment rental",
    "AboutCom":"About company",
    "History":"Zasagt Khaan LLC started its activities in the field of mining exploration and production in 2008. Since 2011, it has expanded its activities in the field of construction of residential and industrial buildings and rental of heavy machinery, and is currently operating in the following areas.",
    "totalPro":"Total implemented projects",
    "totalTehc":"Total technical capacity",
    "danger":"There are no cases of accidents and incapacity for work have occured since its establishments",
    "dangerTotal":"Total number of operators and employees",
    "dangerHuman":"The proportion of employees working from that locality to the total employees",
    "experEngi":"Work experience of engineers and technicians",
    "Ovoot":"Ovoot tolgoi project",
    "OvootHeader":"Ovoot tolgoi",
    "tsankhi":"Coal shipment of Tsankhi West mine",
    "caroHis1":"Southgobi Resources Limited (Southgobi) is a publicly traded coal supplier listed on the Toronto and Hong Kong Stock Exchanges (TSX: SGQ, HK: 1878). Southgobi owns strategic coal deposits with logistics infrastructure and commercial potential. The deposit is located in Gurvan Tes Soum, Umnogovi Province, and has a special license for mining until 2037 on an area of 9,283 hectares.",
    "caroHis1-1":"Since 2022, our company has started cooperating with Southgobi Sands Company, and is carrying out soil stripping and coal mining in Narmandah and Narjargah mines in Ovoot Tolgoi.",
    "caroHis2":"One of the largest untapped coking and thermal coal deposits in the world, located in Umungovi province in southern Mongolia, is a key strategic deposit with a total of 2.9 billion tons of reserves, a quarter of which is high-quality coking coal deposits.",
    "caroHis2-1":" ",
    "more":"More",
    "name":"Name",
    "email":"Email",
    "phone":"Phone number",
    "title":"Title",
    "feedbackDeta":"Feedback Details",
    "feedbackSend":"Send Feedback",
    "feedbackTitle":"Please send your feedback regarding our products and services using the following form. Our information officer will get back to you within 24 hours based on the information you filled out.",
    "feedbackReq":"Send request",
    "contact":"Contact us",
    "centralBnch":"MAIN LOCATION: Umnugovi Province, Dalanzadgad sum No. 6, Ikh Uul, West of the Sport Complex, Tsogjavkhlan Service center 2nd floor door 204.",
    "location": "BRANCH ADDRESS: Mongolia, Ulaanbaatar City, Sukhbaatar District, S.Jamyan street, Khaan Insurance Building Door 306",
    "greeting":"Greeting",
    "introCom":"Company introduction",
    "vision":"Mission, Vision, Value",
    "currentNews":"Current news",
    "comNews":"Company news",
    "socialRes":"Social responsibility",
    "humanPolicy":"Human resource policy",
    "curriculum":"Curriculum",
    "availavleJob":"Available jobs",
    "reverse":"Zasagt Khaan LLC | All rights reserved.",
    "comPhone":"99110583",
    "comEmail":"erdenejargal@zasagt.mn",
    "comFace":"Засагт хаан ХХК",
    
    "aboutIntro":"INTRODUCTION",
    "aboutCourse":"Current course of action",
    "aboutTimeline":"Historical timeline",
    "aboutPro":"About project",
    "proOne":"Southgobi Resources Limited (Southgobi) is a publicly traded coal supplier listed on the Toronto and Hong Kong Stock Exchanges (TSX: SGQ, HK: 1878). Southgobi owns strategic coal deposits with logistics infrastructure and commercial potential. The deposit is located in Gurvan Tes Soum, Umnogovi Province, and has a special license for mining until 2037 on an area of 9,283 hectares. Since 2022, our company has started cooperating with Southgobi Sands Company, and is carrying out soil stripping and coal mining in Narmandah and Narjargah mines in Ovoot Tolgoi.",
    "proTwo":"One of the largest untapped coking and thermal coal deposits in the world, located in Umungovi province in southern Mongolia, is a key strategic deposit with a total of 2.9 billion tons of reserves, a quarter of which is high-quality coking coal deposits.",
    "proCap":"CURRENT CAPACITY OF THE PROJECT",
    "proCapOne":"Zasagt Khaan LLC is operating in Ovoot Tolgoi open-pit mine with about 200 employees with a capacity of 7.5 million m3 of mountain solids per year with scoop loaders and self-unloaders.",
    "proCapTwo":"Erdenes Tavan Tolgoi LLC has been working on the coal loading of the West Tsankhi mine since 2020 and has been producing 4.8 million tons of coal annually.",
    "mechanicTitle":"MEDIUM EQUIPMENT",
    "mechanicTitleSmall":"small equipment",
    "sp1":"1 - 3 million m3/year",
    "sp2":"2 - 7 million m3/year",
    "spp1":"Zasagt Khaan LLC offers a combination of open pit stripping and mining equipment with a capacity of 1.0 - 3.0 million m3/year.",
    "spp2":"Zasagt Khaan LLC offers a combination of open pit stripping and mining equipment with a capacity of 2.0 - 7.0 million m3/year.",
    "spe1":"A combination of small-scale mining equipment",
    "spe2":"A combination of medium-sized open-pit mining equipment",
    "tech1":"Bulldozer",
    "tech2":"Excavator",
    "tech3":"Dump truck",
    "tech4":"Bucket loader",
    "tech5":"Watertrack",
    "tech6":"Auto grader",
    "tech7":"Lighthouse",
    "tech8":"Type ",
    "tech9":"Mark",
    "tech10":"Image ",
    "tech11":"quantity",
    "tech12":"Indicator",
    "policy":"Policy",
    "title1":"By actively supporting the continuous learning and growth of employees, we will form an ethical and competent team and create long-term and sustainable business success.",
    "purpose":"PURPOSE",
    "title2":`<ul class="list-disc list-outside text-justify leading-8"><li>Creating an environment for employees to learn and develop</li><li>Provide market competitive wages, benefits and supplies</li><li>Adopting a culture of a team where employees adhere to ethical norms and work satisfactorily</li><li>Forming a professional team based on knowledge and skills</li></ul>`,
    "procedure":"RECRUITMENT PROCEDURE",
    "title3":"We provide equal and equal opportunities to every citizen who applies for employment, and conduct employee selection in a fair and transparent manner.",
    "upskill":"Upskilling training",
    "ohs":"Occupational Health and Safety (OHS)",
    "openings":"Available jobs"
}

export default en